import React from "react";
import ImageWithFallback from "../../Shared Components/imageWithFallback";

export default function AddOnServices({
  services,
  OnOfferLabel,
  defaultAddOnThumbnail,
}) {
  const exclude_services_from_list = [
    "doubt assistance",
    "instant discount",
    "coupon",
  ];

  return (
    <div className="addOnServicesContainer">
      {services.map((service) => {
        return (service?.service_info?.visible_for || []).includes("web") &&
          !exclude_services_from_list.includes(
            service?.service_info?.service_type
          ) ? (
          <div className="card removeCardSpace orderSummaryCard">
            <div className="row">
              <div className="col-3 col-lg-3 alignSummaryImage pl-4">
                <ImageWithFallback
                  src={service?.service_info?.thumbnail}
                  fallbackSrc={defaultAddOnThumbnail}
                  className="img-fluid"
                />
              </div>
              <div className="col-9 col-lg-9 alignSummaryContent">
                <div className="card-body pb-0 mb-0">
                  <div className="row pb-0">
                    <div className="col-12 mb-2">
                      <OnOfferLabel />
                    </div>
                    <div className="col-8">
                      <h6 className="font-weight-bold text-left rightSectionheading mb-0">
                        {service?.service_info?.offer_name}
                      </h6>
                      <p className="d-sm-block text-left mb-0 rightSectionDesc">
                        Service
                      </p>
                    </div>
                    <div className="col-4">
                      <h6 className="text-right sofia-pro">
                        <span style={{ display: "inline-block" }}>
                          <s>
                            {service?.service_info?.currency_symbol}{" "}
                            {service?.service_info?.price_without_offer}
                          </s>
                          {service?.service_info?.offer_price === 0 ? (
                            <span className="freeChip">FREE</span>
                          ) : (
                            <h6 className="text-right font-weight-bold">
                              {service?.service_info?.currency_symbol}{" "}
                              {service?.service_info?.offer_price}
                            </h6>
                          )}
                        </span>
                      </h6>
                    </div>
                    <p className="col-12 text-left rightSectionDesc mb-1">
                      {service?.service_info?.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null;
      })}
    </div>
  );
}
